import DropShippingRefundDTO from "@/dto/dropShipping/DropShippingRefundDTO";
import RetailerDropShippingInfoDTO from "@/dto/order/RetailerDropShippingInfoDTO";
import { WrapperList } from "@/utils/utilityTypes";
import { get, post } from "@/services/http/platformServer";
import TaskStatus from "@/enum/TaskStatus";

export interface ApplyRefundParams {
    /**
     * 退款原因
     */
    reason?: string;
    /**
     * 代理商订单ID列表
     */
    retailerOrderIds: number[];
    /**
     * 代理商店铺id
     */
    retailerShopId: number;

    /**
     * 买家是否需要退货
     */
    needReturnGoods: boolean;
}

export interface DropShippingRefundResult {
    /**
     * 错误信息
     */
    errorMsg?: string;
    /**
     * 代理商分销信息
     */
    retailerDropShippingInfo: RetailerDropShippingInfoDTO;
    /**
     * 代理商订单ID
     */
    retailerOrderId: number;
    /**
     * 退款是否成功
     */
    successful: boolean;
}

/**
 * 获取退款列表
 */
export function getDropShippingRefundList({ pageNo, pageSize, shopId }): Promise<WrapperList<DropShippingRefundDTO>> {
    return get(shopId, "/drop_shipping_refund/list", { pageNo, pageSize, shopId });
}

interface CancelDropshippingRefundParams {
    retailerShopId: number;

    retailerOrderId: number;
}

/**
 * 代理商取消退款
 */
export function cancelDropshippingRefund(
    shopId: number,
    params: CancelDropshippingRefundParams,
): Promise<RetailerDropShippingInfoDTO> {
    return post(shopId, "/drop_shipping_refund/cancel", params);
}

interface AgreeRefundParams {
    forced: boolean;

    refundId: number;

    shopId: number;
}

interface RefundOrderPreCheckResult {
    /**
     * 是否有电子面单
     * 从订单信息获取
     */
    hasEwaybillNo?: boolean;
    /**
     * 订单电子面单号
     * 从订单信息获取
     */
    waybillNo?: string;
}

/** 处理退款单前预检测退款订单 */
export function preCheckRefundOrder(shopId: number, orderId: number) {
    return post<RefundOrderPreCheckResult>(shopId, "/drop_shipping_refund/pre_check_refund_order", { shopId, orderId });
}

/**
 * 同意退款
 */
export function agreeRefund(params: AgreeRefundParams): Promise<void> {
    return post(params.shopId, "/drop_shipping_refund/agree", params);
}

interface RefuseRefundParams {
    refundId: number;

    shopId: number;
}

/**
 * 拒绝退款
 */
export function refuseRefund(params: RefuseRefundParams): Promise<void> {
    return post(params.shopId, "/drop_shipping_refund/refuse", params);
}

export interface BatchRefundProcess {
    errorMsg?: string;

    status: TaskStatus;

    taskId: string;

    refundResults: DropShippingRefundResult[];
}

export function batchApplyDropShippingRefund(params: ApplyRefundParams): Promise<BatchRefundProcess> {
    return post(params.retailerShopId, "/drop_shipping_refund/async_batch_apply", params);
}

export function dropShippingBatchRefundProcess(shopId, taskId: string): Promise<BatchRefundProcess> {
    return get(shopId, "/drop_shipping_refund/batch_refund_process", { taskId });
}
